import { jsx as n } from "@emotion/react/jsx-runtime";
import a, { linkClasses as e } from "@mui/material/Link";
const o = e, l = ({ to: i, ...s }) => /* @__PURE__ */ n(a, { ...s, href: i || s.href });
l.displayName = "Link";
export {
  l as L,
  o as l
};
